import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../template/store';

import { IDataTableColumn } from '../../common/types/dataTable';
import DataTable from '../../common/components/DataTable';
import CardWrapper from '../../common/components/CardWrapper';
import FilterView from '../../common/components/FilterView';
import { useEffect, useState } from 'react';
import {
  IConfigsDefinition,
} from '../../utils/columnConfig';
import { getDashboardData } from '../dashboard/actions/dashboard';
import { useDispatch } from 'react-redux';

import {
  toggleColumnSettingsDashboard,
  updateColumnDefinition,
  updateColumnDefinitionConfigs,
} from '../dashboard/slices/dashboardSlice';
import { getColumnViews } from '../../common/actions/dataTable';
import { matchPath, Outlet, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { AESEncrypt } from '../../../encrypt-util';
import moment from 'moment';
import { updateDashbaordName } from '../../common/slices/navbarTop';
import { useGenerateColumnConfig } from '../../../hooks/useGenerateColumnConfig';
import DashboardContainer from '../../../components/common/DashboardContainer';
import { updateDashbaordRefresh } from '../../common/components/DataTable/slices/DataTable';

const gridName = 'TEMPLATE_EMAIL_DASHBOARD';
const view = "EMAIL_TEMPLATE"
const filterKey = 'emailTemplate';

const EmailTemplateDashboard = () => {
  // Packages
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();

  // States
  const [columns, setColumns] = useState<IDataTableColumn[]>([]);
  const [configs, setConfigs] = useState<IConfigsDefinition>({
    columns: [],
    staticHiddenCols: [],
    defaultHiddenCols: [],
  });
  const [currentPage, setCurrentPage] = useState<number>(1);
  // Selectors
  const data = useSelector(
    (state: RootState) => state.dashboard.emailTemplateList
  );
  const refresh = useSelector(
    (state: RootState) => state.dataTable.refreshDashboard
  );
  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const language = useSelector((state: RootState) => state.navbarTop.language);
  const selectedConfigId = useSelector(
    (state: RootState) => state.dataTable.selectedConfigId
  );
  const filterState = useSelector(
    (state: RootState) => state.dataTable.filterState
  );
  const emailTemplateGrids = useSelector(
    (state: RootState) => state.dataTable.emailTemplateGrids
  );
  const showColumnSettings = useSelector(
    (state: RootState) => state.dashboard.showColumnSettings
  );
  const onHideColumnSettings = () => {
    dispatch(toggleColumnSettingsDashboard(false));
  };
  const filterStateLocal = filterState?.[filterKey];

  const findFieldsByConfigId = (selectedConfigId: any, configGroup: any) => {
    const matchedConfig = configGroup?.find(
      (config: any) => config?.userGridId == selectedConfigId
    );

    if (matchedConfig && matchedConfig?.columnConfig) {
      const fields = matchedConfig?.columnConfig
        .filter((column: any) => column?.visible === 'true')
        .map((column: any) => column?.accessor);

      return { fields };
    } else {
      return { fields: [] };
    }
  };
  const configGroup = emailTemplateGrids?.[0]?.configGroupGrid;
  const selectedTopSearchFilter = useSelector(
    (state: RootState) => state.navbarTop.selectedTopSearchFilter
  );
  const searchInputValue = useSelector(
    (state: RootState) => state.navbarTop.searchInputValue
  );

  const linerDataCountry = useSelector(
    (state: RootState) => state.userProfile.linerDataCountry
  );
  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );
  const dataCountry = linerDataCountry ?? profileDetails.partnerCountry ?? "";
  useEffect(() => {
    if (dataCountry && linerId) {
      dispatch(
        getColumnViews({ gridName: gridName, country: dataCountry, linerId: linerId, language: language || localStorage.getItem('selectedLanguage') || 'EN' })
      );
      loadEmailTemplateData(true);
    }
  }, [dataCountry, linerId, language]);

  useEffect(() => {
    if (refresh) loadEmailTemplateData(false);
    // server sometimes takes time to update the view so the delay
    setTimeout(() => dispatch(updateDashbaordRefresh(false)), 2000);
  }, [refresh]);


  useEffect(() => {
    loadEmailTemplateData(false);
  }, [currentPage]);
  // const columns = useSelector((state: RootState) => state.dashboard.columns);
  const generateColumnConfig = useGenerateColumnConfig()

  useEffect(() => {
    const emailTemplateRefuncdColumn = emailTemplateGrids?.[0]?.columnConfigGrid || '';

    // const configs = generateColumnConfig(emailRefuncdColumn);
    try {
      const configs = generateColumnConfig(
        JSON.parse(JSON.parse(emailTemplateRefuncdColumn))
      );

      setColumns(configs.columns);
      setConfigs(configs);
      dispatch(updateColumnDefinitionConfigs(configs));
      dispatch(updateColumnDefinition(columns));
    } catch (e: any) {
      console.error('Column Error: ', e);
    }
  }, [emailTemplateGrids]);

  useEffect(() => {
    dispatch(updateDashbaordName(gridName));
  }, [])

  useEffect(() => {
    loadEmailTemplateData(true);
  }, [filterState, location.search, linerId, searchInputValue, language]);

  const loadEmailTemplateData = (filterUpdated: boolean) => {
    const SelectedViewFields = findFieldsByConfigId(
      selectedConfigId?.emailTemplate,
      configGroup
    );
    if (filterUpdated) setCurrentPage(1);
    const sort = (queryString.parse(location.search)?.sort as string)
      ?.split?.(',')
      ?.join?.(' ');
    const filterApiState: any = {};
    if (filterStateLocal /*&& Object.keys(filterStateLocal)?.length > 0*/) {

      const filterKeys = Object.keys(filterStateLocal);

      for (let k of filterKeys) {
        if (filterStateLocal?.[k]?.from) {
          filterApiState[k] = [
            filterStateLocal?.[k]?.from || '',
            filterStateLocal?.[k]?.to || '',
          ].filter((i) => i);
        } else if (filterStateLocal?.[k]?.from !== undefined) {
          filterApiState[k] = undefined;
        } else {
          filterApiState[k] = filterStateLocal?.[k]
            ? typeof filterStateLocal?.[k] === 'string'
              ? [filterStateLocal?.[k]]
              : filterStateLocal?.[k]
            : undefined;
        }
      }
    }
    const finalFilterApiState: any = {};

    for (let i of Object.keys(filterApiState)) {
      if (filterApiState[i]) {
        finalFilterApiState[i] = filterApiState[i];
      }
    }
    if (searchInputValue.trim() !== "") {
      finalFilterApiState[selectedTopSearchFilter.id] = typeof searchInputValue === 'string' ? [searchInputValue] : searchInputValue;
    }
    dispatch(
      getDashboardData({
        gridName: view,
        payload: {
          fields: SelectedViewFields?.fields || [],
          filters: !selectedTopSearchFilter?.where ||
            selectedTopSearchFilter?.where == ''
            ? finalFilterApiState
            : {},
          size: 20,
          sorts: sort ? [sort] : ['template_id desc'],
          page: filterUpdated ? 1 : currentPage,
        },

        dataCountry: dataCountry,
        partnerId:
          profileDetails.partnerType === 'customer'
            ? profileDetails.partnerId
            : null,
        where: emailTemplateGrids?.[0]?.whereClause
          ? AESEncrypt(emailTemplateGrids?.[0]?.whereClause)
          : null,
        parameter:
          selectedTopSearchFilter?.where !== '' &&
            searchInputValue.trim() !== ""
            ? {
              searchParameter: searchInputValue,
              searchWhere: selectedTopSearchFilter?.where,
            }
            : {},
      })
    );

  };
  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';

  const sideWidth =
    Object.entries({
      [`${APP_PATH_PREFIX}/emailTemplateDashboard`]: 0,
      [`${APP_PATH_PREFIX}/emailTemplateDashboard/:email_template_id`]: 10,
    }).find(([path, _]) => matchPath(path, location.pathname))?.[1] ?? 9;

  return (
    <DashboardContainer
      sideWidth={sideWidth}
      middleChildren={
        <div className={`flex-1 h-100 smoothDiv w-100`}>
          <Outlet />
        </div>
      }
    >
      <FilterView
        showExport={true}
        data={data}
        // dashboardName='EMAIL_TEMPLATE_DASHBOARD'
        showColumnSettings={true}
        uniqueFilterKey={filterKey}
        toggleColumnSettings={toggleColumnSettingsDashboard}
        configViews={
          emailTemplateGrids?.find?.((g) => g?.gridName === gridName)
            ?.configGroup || []
        }
        showRightDiv={!!matchPath(location.pathname, '/emailTemplateDashboard')}
        dashboardName={gridName}
        gridDef={emailTemplateGrids}
      />
      {columns.length > 0 && (
        <DataTable
          columns={columns}
          data={data?.result || null}
          pagination
          numberPagination
          maxPage={parseInt(data?.maxPage || '100')}
          hasNext={data?.hasNext}
          currentPage={currentPage}
          showColumnSettings={showColumnSettings}
          onHide={onHideColumnSettings}
          onChangePageNumber={(pageNumber) => setCurrentPage(pageNumber)}
          selection={undefined}
          sortable={undefined}
          perPage={20}
          searchable={false}
          showExport={undefined}
          showColumnFilter={undefined}
          uniqueFilterKey={filterKey}
          defaultHiddenCols={configs?.defaultHiddenCols || []}
          staticHiddenCols={configs?.staticHiddenCols || []}
          gridName={gridName}
          configGroup={
            //  grids?.find?.((g) => g?.gridId === 2)?.configGroup || []
            emailTemplateGrids?.find?.((g) => g?.gridName === gridName)
              ?.configGroup || []
          }
          gridId={emailTemplateGrids?.[0]?.gridId || 0}
          customSort
        />
      )}
    </DashboardContainer>
  );
};

export default EmailTemplateDashboard;
